import { Skeleton } from '@mui/material';
import { useMemo } from 'react';
import Chart from 'react-google-charts';
import { Colors } from 'src/shared/components/styles/colors';
import { chartHelper } from 'src/shared/helpers/chartHelper';
import { useTranslation } from 'react-i18next';
import { FundraiserPaymentsSumPerDate } from '../models/fundraiserResponse';

type FundraiserChartLineProps = {
  loading: boolean;
  chartData: FundraiserPaymentsSumPerDate[] | undefined;
};

export const FundraiserChartLine = (props: FundraiserChartLineProps) => {
  const { loading, chartData } = props;
  const { t } = useTranslation();
  const setchartData = useMemo(() => chartData && chartHelper.transformData(chartData, t('fundraiser:amount')), [chartData, t]);

  const options = {
    curveType: 'function',
    legend: { position: 'bottom' },
    pointSize: 3,
    chartArea: { width: '80%', height: '80%' },
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out',
    },
    vAxis: {
      gridlines: {
        color: 'none',
      },
    },
    yAxis: {},
    colors: [`${Colors.ColorBox.LightBlue}`],
  };

  if (loading) {
    return <Skeleton variant='rectangular' animation='wave' sx={{ mr: { xs: 0, md: 3 }, height: '200px', borderRadius: 1 }} />;
  }

  return <Chart chartType='LineChart' width='100%' height='200px' data={setchartData} options={options} />;
};
